export default function ID2() {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <path id="id" d="M34.143,32A2.143,2.143,0,0,0,32,34.143v5.714A2.143,2.143,0,0,0,34.143,42h5.714A2.143,2.143,0,0,0,42,39.857V34.143A2.143,2.143,0,0,0,39.857,32Zm1.071,2.5a.536.536,0,0,0-1.071,0v5a.536.536,0,0,0,1.071,0Zm1.429-.536a.536.536,0,0,0-.536.536v5a.536.536,0,0,0,.536.536h.714a3.036,3.036,0,1,0,0-6.071Zm.536,5V35.036h.179a1.964,1.964,0,0,1,0,3.929Z" transform="translate(-32 -32)" fill="#8e8e8e" fill-rule="evenodd" />
    </svg>

    )
}